/* src/app/shop/productos/product-custom-elements/product-custom-elements.component.scss */
b {
  font-size: 12px;
}
.selection {
  height: 100%;
}
.optionsTitle,
.option-label,
.option-label .option-value {
  font-weight: 600;
  font-size: 18px;
  font-family: "Barlow Semi Condensed", sans-serif;
}
.option-name {
  color: var(--Escala-de-grises-GRIS-3, #949494);
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.option-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.option-label .option-name {
  display: block;
  margin-right: 5px;
}
.selection-group .selection label,
.selection-group .selection .selector:hover label {
  border: 1px solid #949494;
  border-radius: 10px;
  color: black;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 10px;
  cursor: pointer;
  background-color: white;
  width: 100%;
  height: 100%;
}
.selection-group .selection input[type=radio]:checked ~ .selector label {
  border: none;
}
.selection-group .selection label.disabled {
  color: rgba(0, 154, 207, 0.3);
  outline: 2px solid rgba(0, 154, 207, 0.3);
}
.selection-group .selection .selector:hover label {
  background-color: rgba(67, 192, 246, 0.0509803922);
}
.selection-group .selection .selector:hover label.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  border-color: rgba(0, 154, 207, 0.3);
}
.selection-group .selection input[type=radio] {
  display: none;
}
.selection-group .selection input[type=radio]:checked ~ .selector label {
  background-color: #d4ecff;
}
.selection-group .selection input[type=radio]:checked ~ .selector {
  outline: 1px solid #259dff;
}
.selection {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  height: 100%;
  padding: 4px;
}
.selection .discount-div {
  background: #ff007f;
  color: white;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  z-index: -1;
  margin-top: -15px;
  border-radius: 5px;
}
.selection .discount-div span {
  transform: translateY(6px);
}
.selector {
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
.selector.color {
  width: 43px;
  height: 59px;
  border-radius: 10px;
  position: relative;
  border: none;
  padding: 4px;
}
.selector.preview {
  width: 70px;
  position: relative;
}
.selector.preview svg {
  position: absolute;
}
.selector.preview svg {
  opacity: 65%;
}
.selector.img img {
  width: 50px;
  background: white;
  padding: 8px;
  border-radius: 10px;
}
.selection-group .selection .selector:hover.disabled,
.selection-group .selection input[type=radio]:checked ~ .selector.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  border-color: rgba(0, 154, 207, 0.3);
}
.selection-group.pending {
  opacity: 0.3;
}
ion-segment {
  background: #f4f4f4;
  border-radius: 10px;
  padding: 10px;
}
ion-segment ion-segment-button {
  padding: 10px;
  color: var(--Blanco-y-negro-GRIS-3, #949494);
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: var(--fontSize-16, 16px);
  font-style: normal;
  font-weight: var(--fontWeight-semibold, 600);
  line-height: 18px;
}
ion-segment ion-segment-button.segment-button-checked {
  color: black;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: var(--fontSize-16, 16px);
  font-style: normal;
  font-weight: var(--fontWeight-semibold, 600);
  line-height: 22px;
}
ion-segment ion-segment-button::part(indicator-background) {
  border-radius: 15px;
  border: 1px solid var(--Colores-secundarios-CIAN-OSCURO, #259dff);
  background: var(--Colores-secundarios-CIAN-CLARO, #d4ecff);
}
ion-segment ion-label {
  font-size: 18px;
}
.segment-selection {
  padding: 10px 0 15px 0;
  text-align: center;
}
.segment-selection span {
  color: var(--Colores-secundarios-CIAN-OSCURO, #259dff);
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: var(--fontSize-18, 18px);
  font-style: normal;
  font-weight: var(--fontWeight-semibold, 600);
  line-height: normal;
}
.option-card {
  background-color: white;
  border-radius: 15px;
  padding-left: 9px;
  padding-right: 9px;
  padding-top: 3px;
  padding-bottom: 3px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px;
  width: 100%;
}
.selector label span {
  color: #949494;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
}
.cuadro-color {
  height: 50px !important;
  width: 50px !important;
  border-radius: 5px !important;
}
#label-optional {
  color: #949494;
}
ion-segment-button ion-label {
  text-overflow: clip;
  overflow: visible;
  text-wrap: pretty;
}
.paper-color-input:checked ~ .selector {
  border-radius: 5px !important;
  outline: 3px solid rgba(67, 192, 246, 0.8) !important;
}
.categoryTitle {
  color: var(--Blanco-y-negro-GRIS-3, #949494);
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: var(--fontSize-16, 16px);
  font-style: normal;
  font-weight: var(--fontWeight-semibold, 600);
  line-height: 22px;
}
.binding-option {
  margin-bottom: 10px;
}
.binding-option img {
  max-width: 30px;
}
.binding-option .option-name {
  color: black;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.binding-option .option-subtitle {
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
ion-segment {
  border-radius: 20px;
  border-top: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  border-right: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  border-left: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6);
}
.binding-options-body {
  padding: 10px;
  border-radius: 15px;
  border-right: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  border-bottom: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  border-left: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6);
}
.binding-options-body .selection-group .selection input[type=radio]:checked ~ .selector {
  border-radius: 10px;
  border: 2px solid var(--Colores-primarios-CIAN, #43c0f6);
  background: var(--Blanco-y-negro-BLANCO, #fff);
  box-shadow: 0px 0px 15px 0px #43c0f6;
}
/*# sourceMappingURL=product-custom-elements.component-EX4222NW.css.map */
